module.exports = __webpack_public_path__ + "static/media/portfolio.19ced0b9.jpg";